<template>
  <div>

    <p class="mb-10 mt-10" style="font-size: 25pt; text-align: center">
      INDICES
    </p>

    <v-card outlined>
      <v-toolbar flat>
        <v-btn @click="irAtras" icon>
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <v-toolbar-title class="grey--text"
          >{{ indices.length }} Indices</v-toolbar-title
        >

        <v-spacer></v-spacer>

        <v-btn depressed color="secondary" @click="showDialogAddIndice">
          <v-icon left dark> mdi-plus </v-icon>
          Agregar Indice
        </v-btn>
      </v-toolbar>

      <v-divider></v-divider>

      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field
              label="Buscar Variable"
              outlined
              hide-details="auto"
              prepend-inner-icon="mdi-magnify"
              v-model="searchQuery"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-list two-line subheader>
              <v-list-item
                v-for="item in filterBy(indices, item => filterItems(item))"
                :key="item.Name.es"
                @click="irIndice(item)"
              >
                <v-list-item-content>
                  <v-list-item-title style="font-weight: 500">{{
                    item.Name.es
                  }}</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ item.Id }}
                    <br />
                    {{ item.Data.Count }} Ubicaciones
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-menu bottom left>
                    <template v-slot:activator="{ on }">
                      <v-btn icon v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>

                    <v-list dense>
                      <v-list-item @click="showDialogEditIndice(item)">
                        <v-list-item-icon class="mr-3">
                          <v-icon color="blue-grey">mdi-pencil-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>Editar</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="deleteIndice(item.Id)">
                        <v-list-item-icon class="mr-3">
                          <v-icon color="red">mdi-delete-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>Eliminar</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="addIndiceDialog" persistent max-width="700px">
      <v-card>
        <v-toolbar flat color="primary" dark>
          <v-toolbar-title>Agregar Nuevo Indice</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="addIndiceDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pb-2 pt-2">
          <v-container>
            <v-form ref="formAddIndice">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="newIndice.Name.es"
                    label="Nombre Indice"
                    outlined
                    hide-details="auto"
                    required
                    :rules="rules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="newIndice.Description.es"
                    label="Descripción Indice"
                    outlined
                    rows="4"
                    counter="300"
                    :rules="rules"
                  ></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="newIndice.Data.Sdgs"
                    :items="dataForm.sdgs"
                    label="Objetivos de Desarrollo Sostenible"
                    return-object
                    item-text="name.es"
                    outlined
                    multiple
                    chips
                    hide-details="auto"
                    :rules="rulesMultiple"
                    required
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        dark
                        :color="data.item.color"
                        @click="data.select"
                        >{{ data.item.name.es }}</v-chip
                      >
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            large
            @click="cancelDialogAddIndice()"
            >Cancelar</v-btn
          >
          <v-btn text @click="addIndice(newIndice)" large>Guardar</v-btn>
        </v-card-actions>
        <v-overlay :absolute="true" :value="loadingAddIndice">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editIndiceDialog" persistent max-width="700px">
      <v-card>
        <v-toolbar flat color="primary" dark>
          <v-toolbar-title>Editar Indice</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="editIndiceDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-form ref="formUpdateIndice">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="updateIndice.Name.es"
                    label="Nombre Indice"
                    outlined
                    hide-details="auto"
                    required
                    :rules="rules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <v-textarea
                    v-model="updateIndice.Description.es"
                    label="Descripción Indice"
                    outlined
                    rows="4"
                    counter="1000"
                    :rules="rules"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="updateIndice.Data.Sdgs"
                    :items="dataForm.sdgs"
                    label="Objetivos de Desarrollo Sostenible"
                    return-object
                    item-text="name.es"
                    outlined
                    multiple
                    chips
                    hide-details="auto"
                    :rules="rulesMultiple"
                    required
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        dark
                        :color="data.item.color"
                        @click="data.select"
                        >{{ data.item.name.es }}</v-chip
                      >
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            large
            @click="cancelDialogUpdateIndice()"
            >Cancelar</v-btn
          >
          <v-btn text @click="actualizarIndice(updateIndice)" large
            >Actualizar</v-btn
          >
        </v-card-actions>
        <v-overlay :absolute="true" :value="loadingUpdateIndice">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar.show"
      bottom
      :color="snackbar.color"
      :timeout="5000"
      >{{ snackbar.text }}</v-snackbar
    >
  </div>
</template>

<script>
import api from "@/api/api";
import Vue2Filters from "vue2-filters";


export default {
  name: "Indices",
  mixins: [Vue2Filters.mixin],
  data() {
    return {
      searchQuery: "",
      indices: [],
      newIndice: {
        Name: {
          es: null,
        },
        Description: {
          es: null,
        },
        Data: {},
      },
      dataForm: {
        sdgs: [
          {
            id: 1,

            name: {
              es: "Fin de la pobreza",
            },
            color: "#e5243b",
            imageUrl: {
              es:
                "https://i2.wp.com/www.un.org/sustainabledevelopment/es/wp-content/uploads/sites/3/2016/01/S_SDG_Icons-01-01.jpg?w=1350",
            },
          },
          {
            id: 2,

            name: {
              es: "Hambre Cero",
            },
            color: "#e5b735",
            imageUrl: {
              es:
                "https://i2.wp.com/www.un.org/sustainabledevelopment/es/wp-content/uploads/sites/3/2016/01/S_SDG_Icons-01-02.jpg?w=1350",
            },
          },
          {
            id: 3,

            name: {
              es: "Salud y Bienestar",
            },
            color: "#4c9f38",
            imageUrl: {
              es:
                "https://i2.wp.com/www.un.org/sustainabledevelopment/es/wp-content/uploads/sites/3/2016/01/S_SDG_Icons-01-03.jpg?w=1350",
            },
          },
          {
            id: 4,

            name: {
              es: "Educación de Calidad",
            },
            color: "#c5192d",
            imageUrl: {
              es:
                "https://i2.wp.com/www.un.org/sustainabledevelopment/es/wp-content/uploads/sites/3/2016/01/S_SDG_Icons-01-04.jpg?w=1350",
            },
          },
          {
            id: 5,

            name: {
              es: "Igualdad de Género",
            },
            color: "#ff3a21",
            imageUrl: {
              es:
                "https://i2.wp.com/www.un.org/sustainabledevelopment/es/wp-content/uploads/sites/3/2016/01/S_SDG_Icons-01-05.jpg?w=1350",
            },
          },
          {
            id: 6,

            name: {
              es: "Agua Limpia y Saneamiento",
            },
            color: "#26bde2",
            imageUrl: {
              es:
                "https://i2.wp.com/www.un.org/sustainabledevelopment/es/wp-content/uploads/sites/3/2016/01/S_SDG_Icons-01-06.jpg?w=1350",
            },
          },
          {
            id: 7,

            name: {
              es: "Energia Asequible y no Contaminante",
            },
            color: "#fcc30b",
            imageUrl: {
              es:
                "https://i2.wp.com/www.un.org/sustainabledevelopment/es/wp-content/uploads/sites/3/2016/01/S_SDG_Icons-01-07.jpg?w=1350",
            },
          },
          {
            id: 8,

            name: {
              es: "Trabajo Decente y Crecimiento Económico",
            },
            color: "#a21942",
            imageUrl: {
              es:
                "https://i2.wp.com/www.un.org/sustainabledevelopment/es/wp-content/uploads/sites/3/2016/01/S_SDG_Icons-01-08.jpg?w=1350",
            },
          },
          {
            id: 9,

            name: {
              es: "Industria Innovación e Infraestructura",
            },
            color: "#fd6925",
            imageUrl: {
              es:
                "https://i2.wp.com/www.un.org/sustainabledevelopment/es/wp-content/uploads/sites/3/2016/01/S_SDG_Icons-01-09.jpg?w=1350",
            },
          },
          {
            id: 10,

            name: {
              es: "Reducción de las Desigualdades",
            },
            color: "#dd1367",
            imageUrl: {
              es:
                "https://i2.wp.com/www.un.org/sustainabledevelopment/es/wp-content/uploads/sites/3/2016/01/S_SDG_Icons-01-10.jpg?w=1350",
            },
          },
          {
            id: 11,

            name: {
              es: "Ciudades y Comunidades Sostenibles",
            },
            color: "#fd9d24",
            imageUrl: {
              es:
                "https://i2.wp.com/www.un.org/sustainabledevelopment/es/wp-content/uploads/sites/3/2016/01/S_SDG_Icons-01-11.jpg?w=1350",
            },
          },
          {
            id: 12,

            name: {
              es: "Producción y Consumo Responsables",
            },
            color: "#c9992d",
            imageUrl: {
              es:
                "https://i2.wp.com/www.un.org/sustainabledevelopment/es/wp-content/uploads/sites/3/2016/01/S_SDG_Icons-01-12.jpg?w=1350",
            },
          },
          {
            id: 13,

            name: {
              es: "Acción por el Clima",
            },
            color: "#3f7e44",
            imageUrl: {
              es:
                "https://i2.wp.com/www.un.org/sustainabledevelopment/es/wp-content/uploads/sites/3/2016/01/S_SDG_Icons-01-13.jpg?w=1350",
            },
          },
          {
            id: 14,

            name: {
              es: "Vida Submarina",
            },
            color: "#0a97d9",
            imageUrl: {
              es:
                "https://i2.wp.com/www.un.org/sustainabledevelopment/es/wp-content/uploads/sites/3/2016/01/S_SDG_Icons-01-14.jpg?w=1350",
            },
          },
          {
            id: 15,

            name: {
              es: "Vida de Ecosistemas Terrestres",
            },
            color: "#56c02b",
            imageUrl: {
              es:
                "https://i2.wp.com/www.un.org/sustainabledevelopment/es/wp-content/uploads/sites/3/2016/01/S_SDG_Icons-01-15.jpg?w=1350",
            },
          },
          {
            id: 16,

            name: {
              es: "Paz, Justicia e Instituciones Sólidas",
            },
            color: "#00689d",
            imageUrl: {
              es:
                "https://i2.wp.com/www.un.org/sustainabledevelopment/es/wp-content/uploads/sites/3/2016/01/S_SDG_Icons-01-16.jpg?w=1350",
            },
          },
          {
            id: 17,

            name: {
              es: "Alianzas para lograr los objetivos",
            },
            color: "#19486a",
            imageUrl: {
              es:
                "https://i2.wp.com/www.un.org/sustainabledevelopment/es/wp-content/uploads/sites/3/2016/01/S_SDG_Icons-01-17.jpg?w=1350",
            },
          },
        ],
      },
      addIndiceDialog: false,
      loadingAddIndice: false,
      editIndiceDialog: false,
      updateIndice: {
        Name: {
          es: null,
        },
        Description: {
          es: null,
        },
        Data: {},
      },
      loadingUpdateIndice: false,
      rules: [(v) => !!v || "Este campo es requerido"],
      rulesMultiple: [
        (v) => {
          if (!v || v.length < 1) {
            return "Este campo es requerido";
          } else {
            return true;
          }
        },
      ],
      snackbar: {
        show: false,
        text: null,
        color: null,
      },
    };
  },
  mounted() {
    this.getIndices();
  },
  methods: {
    async addIndice(newIndice) {
      if (this.$refs.formAddIndice.validate()) {
        this.loadingAddIndice = true;
        const data = await api.addIndice(newIndice);
        this.loadingAddIndice = false;
        if (data.status) {
          this.addIndiceDialog = false;
          this.newIndice = {
            Name: {
              es: null,
            },
            Description: {
              es: null,
            },
            Data: {},
          };
          this.$refs.formAddIndice.reset();
          this.getIndices();
        }
      }
    },
    async getIndices() {
      try {
        const data = await api.getIndices();

        if (data.status) {
          this.indices = data.data;
          // console.log(data.data);
        }
      } catch (err) {
        console.log(err);
      }
    },
    filterItems(item){
      let result = true
      if (this.searchQuery)
        result = item.Name.es.toLowerCase().includes(this.searchQuery.toLowerCase()) && result;
      return result;
    },
    showDialogAddIndice() {
      this.addIndiceDialog = true;
    },
    showDialogEditIndice(item) {
      this.editIndiceDialog = true;
      this.updateIndice = item;
    },
    cancelDialogUpdateIndice() {
      this.editIndiceDialog = false;
    },
    async actualizarIndice(updateIndice) {
      if (this.$refs.formUpdateIndice.validate()) {
        this.loadingUpdateIndice = true;
        const data = await api.updateIndice(updateIndice);
        this.loadingUpdateIndice = false;
        if (data.status) {
          this.showSnackbar("El indice se actualizó correctamente", "success");
          this.editIndiceDialog = false;
        } else {
          console.log(data.err);
        }
      }
    },
    async deleteIndice(idIndice) {
      try {
        this.loadingScreen = true;
        let data = await api.deleteIndice(idIndice);
        this.loadingScreen = false;
        this.showSnackbar("El indice se eliminó correctamente", "success");
        this.getIndices();
      } catch (err) {
        console.err(err);
      }
    },
    showSnackbar(message, color) {
      this.snackbar.text = message;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },
    irIndice(item) {
      this.$router.push(`/admin/indices/${item.Id}`);
    },
    irAtras() {
      this.$router.go(-1);
    },
  },
};
</script>
